import type { FormValues } from "./data-types";

// validationValue typed as unknown then cast as number or Record
// where needed. Maybe metaprogramming in TypeScript was a bad idea...
const validate = {
  true(userEnteredValue: unknown) {
    return userEnteredValue === true;
  },
  presence(userEnteredValue: unknown) {
    if (typeof userEnteredValue === "string") {
      return !!userEnteredValue && !!userEnteredValue.trim();
    }

    if (Array.isArray(userEnteredValue)) {
      return !!userEnteredValue.length;
    }

    if (typeof userEnteredValue === "boolean") {
      return userEnteredValue === true || userEnteredValue === false;
    }

    return !!userEnteredValue;
  },

  maxLength(userEnteredValue: unknown, validationValue: unknown) {
    const vv = validationValue as number;
    if (typeof userEnteredValue !== "string") {
      return false;
    }

    return userEnteredValue.length <= vv;
  },

  minLength(userEnteredValue: unknown, validationValue: unknown) {
    const vv = validationValue as number;
    if (typeof userEnteredValue !== "string") {
      return false;
    }

    return userEnteredValue.length > vv;
  },

  email(userEnteredValue: unknown) {
    if (!userEnteredValue) {
      return true;
    }

    if (typeof userEnteredValue !== "string") {
      return false;
    }
    const re = /^[\w-!#$%&'*+-/=?^_`{|}~]+@([\w-]+\.)+[\w-]{2,4}$/m;
    return re.test(userEnteredValue.toLowerCase());
  },

  uniqueTo(
    userEnteredValue: unknown,
    validationValue: unknown,
    formValues: FormValues,
  ) {
    const vv = validationValue as Record<string, string>;
    const fromValue = formValues[vv["from"]];

    if (typeof userEnteredValue === "string" && typeof fromValue === "string") {
      return userEnteredValue.toLowerCase() !== fromValue.toLowerCase();
    }

    return userEnteredValue !== fromValue;
  },
};

// conditionValue typed as unknown then cast as number or Record
// where needed. Maybe metaprogramming in TypeScript was a bad idea...
const errorMessages = {
  email: function () {
    return "Please enter a valid email address" as const;
  },

  phone: function () {
    return "Please enter a valid phone number" as const;
  },

  true() {
    return "Please complete this required field" as const;
  },

  presence() {
    return "Please complete this required field" as const;
  },

  radio() {
    return "Please select an option" as const;
  },

  maxLength: function (conditionValue: unknown) {
    const max = conditionValue as number;
    return `Please enter a value shorter than ${max} characters` as const;
  },

  minLength(conditionValue: unknown) {
    const max = conditionValue as number;
    return `Please enter a value greater than ${max} characters` as const;
  },

  uniqueTo(conditionValue: unknown): string {
    const config = conditionValue as Record<string, string>;
    return config["errorMessage"];
  },
} as const;

export type TErrorMessageKey = keyof typeof errorMessages;

export { errorMessages, validate };
